module.exports = __webpack_public_path__ + "img/ar-hero.86c37a7c.jpg";